export default __webpack_public_path__ + "static/oghome-61491698f12cc32b2129f72cc8613013.png";